module.exports = __webpack_public_path__ + "static/024.thumb-d24e48a8d2a29ea61c1bcfaced9b239b.jpg";